import { httpClient } from './api/httpClient';
import { API_ENDPOINTS } from 'constants/apiEndpoints';

const toNotification = (raw) =>
  raw && {
    id: raw.id,
    isCommon: raw.is_common,
    type: raw.type,
    module: raw.module,
    title: raw.title,
    message: raw.message,
    historyDays: raw.history_days,
    notificationDays: raw.notification_days,
    pendingDays: raw.pending_days,
    generatedCount: raw.generated_count,
    lastCalculatedCount: raw.last_calculated_count,
    notificationCycle: raw.notification_cycle,
    generatedAt: raw.generated_at,
    updatedAt: raw.updated_at,
    filters: raw.filters ?? {},
    navigation: raw.navigation ?? {},
    isRead: raw.is_read ?? false,
  };

export const notificationService = {
  async list() {
    const data = await httpClient.get(API_ENDPOINTS.NOTIFICATIONS.LIST);
    return (Array.isArray(data) ? data : []).map(toNotification);
  },

  async getUnreadCount() {
    const data = await httpClient.get(API_ENDPOINTS.NOTIFICATIONS.UNREAD_COUNT);
    return data?.count ?? 0;
  },

  async markRead(id) {
    return toNotification(
      await httpClient.put(API_ENDPOINTS.NOTIFICATIONS.MARK_READ(id))
    );
  },

  async markAllRead() {
    return await httpClient.put(API_ENDPOINTS.NOTIFICATIONS.MARK_ALL_READ);
  },
};

export default notificationService;
